<template>
    <a :href="`/product/${product.slug}`" class="d-block">
        <div class="card product-card item">
            <img v-if="product.gallery[0]?.thumb_url" :src="product.gallery[0]?.thumb_url" class="card-img-top product-card__img" :alt="product.title"/>
            <img v-else src="/images/placeholder.png" class="card-img-top product-card__img" :alt="product.title"/>
            <div class="card-body product-card__body">
                <h5 class="card-title product-card__title product-card__title--off">{{product.title}}</h5>
                <div class="product-card__info">
                    <div v-if="product.stock_status" class="product-card__price product-card__price--off">
                        <div v-if="product.discount" class="product-card__original-price">
                            <span class="product-card__money-figure">{{numberFormat(product.regular_price)}}</span>
                            <span class="product-card__badge badge rounded-pill">%{{product.discount_percentage}}</span>
                        </div>
                        <div class="product-card__off-price">
                            <span class="product-card__money-figure">{{numberFormat(product.final_price)}}</span>
                            <span class="product-card__monetary-unit">تومان</span>
                        </div>
                    </div>
                    <div v-else class="product-card__price product-card__price--off">ناموجود</div>
                </div>
            </div>
        </div>
    </a>
</template>

<script>
export default {
    name: "ProductCard",
    props: {
        product: {required: true, type: Object}
    }
}
</script>

<style scoped>

</style>
